// extracted by mini-css-extract-plugin
export default {"root":"Card_root__UAmJF","left":"Card_left__7EKql","iconContainer":"Card_iconContainer__GN07d","header":"Card_header__LgAhk"};